import { render, staticRenderFns } from "./FlashcardsIntro.vue?vue&type=template&id=064d6802&scoped=true&"
import script from "./FlashcardsIntro.vue?vue&type=script&lang=js&"
export * from "./FlashcardsIntro.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardsIntro.vue?vue&type=style&index=0&id=064d6802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064d6802",
  null
  
)

export default component.exports